import axios from '@/request';
import qs from 'qs';

export default {
  async fans(params: any) {
    return axios.get('wechat/fans/list', { params });
  }
};
